import { SessionProvider } from 'ess-plugin-base';

export class ResLinkAction {
    namespace: string;
    name: string;
    caption: string;
    i18n: string;
    icon: string;
    route: string;
    plugin: string;

    constructor(private session: SessionProvider) {}

    private getUrl(target: any) {
        let url = this.route;
        if (url && url.length && target) {
            for(let key of Object.keys(target)) {
                url = url.replace(':' + key, target[key]);
                url = url.replace('{{' + key + '}}', target[key]);
            }
        }
        return url;
    }

    public async run(target: any) {

        if (this.route) {
            let url = this.getUrl(target);
            if (url && url.length) {

                this.session.addAlert({
                    action: 'command',
                    type: 'res-link',
                    payload: {
                        plugin: this.plugin,
                        route: url
                    }
                })
            }
        }


        // if (this.plugin) {
        //     await this.platform.loadPlugin(this.plugin); 
        // }
        // if (this.route) {
        //     let url = this.getUrl(target);
        //     if (url && url.length) {
        //         this.platform.goto(url);
        //     }
        // }
    }
}